/*
  The gift wrap checkbox on the product page.

  The wrap is its own product, so ticking the box adds a cart line and
  unticking removes it. Both hand the refreshed sections back to the theme so
  the drawer and the counters update the way they do for any other cart change.
*/

if (!customElements.get('gift-wrap-toggle')) {
  class GiftWrapToggle extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-gift-wrap-toggle]');
      this.checkbox?.addEventListener('change', () => this.toggle());
    }

    get root() {
      return window.Shopify?.routes?.root || '/';
    }

    get sections() {
      const drawer = document.querySelector('cart-drawer');
      const ids = (drawer?.getSectionsToRender?.() || []).map((section) => section.section);
      return ids.length ? ids.join(',') : 'cart-drawer,cart-counter';
    }

    async toggle() {
      const wanted = this.checkbox.checked;
      this.checkbox.disabled = true;

      try {
        const data = wanted ? await this.add() : await this.remove();
        if (data) this.announce(data);
      } catch (error) {
        console.error('Gift wrap could not be updated', error);
        /* Put the box back where the cart actually is. */
        this.checkbox.checked = !wanted;
      } finally {
        this.checkbox.disabled = false;
      }
    }

    async add() {
      const response = await fetch(`${this.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
          sections: this.sections,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw data;
      return data;
    }

    async remove() {
      const cart = await fetch(`${this.root}cart.js`).then((r) => r.json());
      const line = cart.items.find((item) => item.variant_id === Number(this.dataset.variantId));
      if (!line) return null;

      /* Removing by key rather than index keeps it correct when the cart has
         several lines of the same variant with different properties. */
      const response = await fetch(`${this.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: line.key, quantity: 0, sections: this.sections }),
      });

      const data = await response.json();
      if (!response.ok) throw data;
      return data;
    }

    announce(data) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gift-wrap-toggle',
          productVariantId: Number(this.dataset.variantId),
          cartData: data,
        });
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data, false);
      }

      if (typeof updateCartCounters === 'function') updateCartCounters();
    }
  }

  customElements.define('gift-wrap-toggle', GiftWrapToggle);
}
